import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ApprovalFlow  {
    _originalTypeClassName = "zERP.BO.ApprovalFlow";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ApprovalFlow.translate = translateService;
}
this.Scenarios = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.SystemModule = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
SystemModule:any;
Scenarios:any;
static setScenarios = ($this, items) => {
                if (items == null) items = [];
                if ($this.Scenarios == null) $this.Scenarios = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Scenarios.length > 0) {
                    Domain.ApprovalFlow.removeScenarios($this, $this.Scenarios[0]);
                }

                Domain.ApprovalFlow.addManyScenarios($this, copyItems);
            }
static addManyScenarios = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ApprovalFlow.addScenarios($this, items[i]);
                }
            }
static addScenarios = ($this, item) => {
                if ($this.Scenarios == null) $this.Scenarios = [];
                if (item == null || $this.Scenarios.indexOf(item) > -1) return;
                $this.Scenarios.push(item);
if (item.ApprovalFlow != $this) {
Domain.ApprovalFlowScenario.setApprovalFlow(item, $this);
}
}
static addRangeScenarios = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ApprovalFlow.addScenarios($this, item));
            }
static removeScenarios = ($this, item) => {
                if ($this == null || $this.Scenarios == null || $this.Scenarios.indexOf(item) === -1) return;
                var _index = $this.Scenarios.indexOf(item);
                $this.Scenarios.splice(_index, 1);
item.ApprovalFlow = null;
}
static clearScenarios = ($this) => { $this.Scenarios = null; }

static GetScenario($this: any, contract: any): any{return $this?.Scenarios?.linq?.where((s) => Domain.ApprovalFlowScenario.IsMatch(s, contract?.Department))?.toArray()?.linq?.orderByDescending((p) => p?.Score)?.toArray()?.linq?.where()?.firstOrDefault(null);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}